export function prepareHtml(html) {
  if (!html) {
    return;
  }

  html = html.replace(/\<p[^>]*\>(?:\s|&nbsp;)*\<\/p\>/g, '');

  return { __html: html };
}

export function prepareWidgetTextoHtml(html) {
  if (!html) {
    return;
  }

  const normalized = html
    .replace(/&nbsp;|&#160;/gi, ' ')
    .replace(/<p([^>]*)>\s*<\/p>/gi, '<p$1><br></p>');

  return { __html: normalized };
}

export function stripHtml(html) {
  let tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
}

export function looksLikeHtml(text) {
  return typeof text === 'string' && /<[a-z][\s\S]*>/i.test(text);
}

/** Texto legível (textarea, InfoPanel, etc.); HTML do banco vira texto. */
export function orientacaoTextoForEdit(text) {
  if (!text) {
    return '';
  }
  return looksLikeHtml(text) ? stripHtml(text) : text;
}

export function formatTextToHtml(text) {
  if (!text) return '';

  const lines = text.split('\n').filter((line) => line.trim() !== '');
  let html = '';
  let isList = false;

  lines.forEach((line) => {
    if (line.trim().startsWith('•')) {
      if (!isList) {
        html += '<ul class="list-disc pl-5">';
        isList = true;
      }
      html += `<li>${line.replace(/^•\s*/, '')}</li>`;
    } else {
      if (isList) {
        html += '</ul>';
        isList = false;
      }
      html += `<p>${line}</p>`;
    }
  });

  if (isList) {
    html += '</ul>';
  }

  return html;
}
